import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (cancelled) return;
        // Accept either "paid" (immediate payment) OR trialing (subscription mode with trial)
        if (data.payment_status === "paid" || data.subscription_status === "trialing" || data.subscription_status === "active") {
          setStatus("paid");
          refresh();
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
        if (attempts++ < 8) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center">
      {status === "pending" && (
        <>
          <Loader2 className="h-12 w-12 mx-auto animate-spin text-[#6B6B6B]" />
          <h1 className="font-display text-3xl mt-6">Verifica pagamento in corso...</h1>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="h-16 w-16 mx-auto rounded-full bg-[#34D399]/20 flex items-center justify-center">
            <Check className="h-8 w-8 text-[#34D399]" />
          </div>
          <h1 className="font-display text-4xl mt-6">Abbonamento attivato</h1>
          <p className="text-[#6B6B6B] mt-3">Benvenuto in ORIO Premium. Il tuo accesso è ora illimitato.</p>
          <Link to="/app" className="mt-8 inline-block px-6 py-3 rounded-full bg-white text-black font-medium">
            Vai alla mappa
          </Link>
        </>
      )}
      {(status === "expired" || status === "error" || status === "timeout") && (
        <>
          <h1 className="font-display text-3xl">Pagamento non confermato</h1>
          <p className="text-[#6B6B6B] mt-2">Riprova o controlla i dettagli.</p>
          <Link to="/billing" className="mt-6 inline-block px-6 py-3 rounded-full bg-[#F0EBE3] text-[#1A1A1A]">
            Torna al checkout
          </Link>
        </>
      )}
    </div>
  );
}
